import axiosV1 from "@/plugins/axios/configV1";

export default {
    fetchImage(url) {
        return axiosV1.get(url);
    },

    saveUrl() {
        return axiosV1.post("audit-log", { url: window.location.href });
    },
};
